import React from 'react';
import { Modal, Pressable, View } from 'react-native';
import { KeyboardAvoidingView } from 'react-native-keyboard-controller';
import { Ionicons } from '@expo/vector-icons';

import { ThemedText } from '@/components/themed-text';
import { PhoneAuthPanel } from '@/components/auth/phone-auth-panel';

interface AddWhatsappModalProps {
  open: boolean;
  onDismiss: () => void;
  onSaved?: () => void;
}

/**
 * WhatsApp como forma de entrar para quem já tem conta (email ou Google/Apple).
 *
 * Aditivo: o número passa a valer junto com o que já existe, nada é trocado.
 * Reaproveita o `PhoneAuthPanel` no modo `link`.
 */
export function AddWhatsappModal({ open, onDismiss, onSaved }: AddWhatsappModalProps) {
  return (
    <Modal visible={open} transparent animationType="slide" onRequestClose={onDismiss}>
      <Pressable className="flex-1 justify-end bg-black/50" onPress={onDismiss}>
        <KeyboardAvoidingView behavior="padding">
          <Pressable
            onPress={(e) => e.stopPropagation()}
            className="rounded-t-3xl bg-card p-6 pb-10"
            style={{ borderCurve: 'continuous' }}
          >
            <View className="mb-4 flex-row items-center justify-between">
              <ThemedText className="font-bold text-xl">Adicionar WhatsApp</ThemedText>
              <Pressable
                onPress={onDismiss}
                className="h-9 w-9 items-center justify-center rounded-full bg-neutral-100"
                accessibilityLabel="Fechar"
              >
                <Ionicons className="text-neutral-600" name="close" size={18} />
              </Pressable>
            </View>

            <ThemedText className="mb-5 text-sm leading-5 text-neutral-500">
              Confirme o número e ele passa a entrar na sua conta também. Seu login atual continua
              valendo.
            </ThemedText>

            <PhoneAuthPanel
              mode="link"
              onLinked={() => {
                onSaved?.();
                onDismiss();
              }}
            />
          </Pressable>
        </KeyboardAvoidingView>
      </Pressable>
    </Modal>
  );
}
